import { useEffect, useState } from 'react'

import { useDebouncedCallback } from 'use-debounce'

// ///////////////////////
// MARK: EXPORTS
export function useWindowSize(): [width: number, height: number] {
  const [size, setSize] = useState<[width: number, height: number]>(() => [
    window.innerWidth,
    window.innerHeight,
  ])

  const setSizeDebounced = useDebouncedCallback((width: number, height: number) => {
    setSize([width, height])
  }, 100)

  useEffect(() => {
    const update = () => {
      setSizeDebounced(window.innerWidth, window.innerHeight)
    }

    window.addEventListener('resize', update)

    return () => window.removeEventListener('resize', update)
  }, [setSizeDebounced])

  return size
}
